import { BusinessArea, SalesChannel } from '@/api/Cart/cart.interfaces';
import { MyBookingStatus, ProductType } from '@/api/MyBooking/myBooking.interfaces';
import { LoanType } from '@/api/LeaBank/leaBank.interfaces';

export enum DevPanelPage {
    Unknown = 'Unknown',
    Checkout = 'Checkout',
    PreCheckout = 'PreCheckout',
    Booking = 'Booking',
    Bookings = 'Bookings',
    Payment = 'Payment',
}
export interface FakeData {
    enabled: boolean;
    log: boolean;
    auth: FakeDataAuth;
    chatWidget: FakeDataChatWidget;
    products: FakeDataProduct[];
    checkout: FakeDataCheckout;
    booking: FakeDataBooking;
    bookingSession: FakeDataBookingSession;
    bookings: FakeDataBookings;
    preCheckout: FakeDataPreCheckout;
}

export interface FakeDataChatWidget {
    enabled: boolean;
}

export interface FakeDataAuth {
    enabled: boolean;
    member: FakeDataAuthMember;
}

interface FakeDataAuthMember {
    canBeSembonusUser: boolean;
    isSembonusUser: boolean;
}

export type FakeDataProduct =
    | FakeDataProductFlight
    | FakeDataProductFerry
    | FakeDataProductHotel
    | FakeDataProductActivity
    | FakeDataProductTransfer;

interface FakeDataProductBase {
    id: string;
    type: string;
    trip: {
        id: string;
    };
}

interface FakeDataProductHotel extends FakeDataProductBase {
    type: 'Hotel';
}

interface FakeDataProductActivity extends FakeDataProductBase {
    type: 'Activity';
}

export interface FakeDataProductFlight extends FakeDataProductBase {
    type: 'Flight';
    isRoundTrip: boolean;
    platingCarrier: string;
}

export interface FakeDataProductFerry extends FakeDataProductBase {
    type: 'Ferry';
    isRoundTrip: boolean;
}

interface FakeDataProductTransfer extends FakeDataProductBase {
    type: 'Transfer';
}

export interface FakeDataCheckout {
    version: string;
    search: FakeDataSearch;
    loan: FakeDataLoan;
    affiliate: FakeDataAffiliate;
    bookingSalesChannels: string[];
    hasAgency: boolean;
    hasAddonLuggage: boolean;
    hasAddonCancellation: boolean;
    hasAddonServicePackage: boolean;
    hasBonusNights: boolean;
    hasAddonTravelInsurance: boolean;
    hasPaymentDiscount: boolean;
    hasCampaignDiscount: boolean;
    hasAmountAlreadyPaid: boolean;
    combinationIdType: CombinationIdType;
    cancellationType: DevCancellationType;
}

export interface FakeDataPreCheckout {
    hasFerryAddons: boolean;
    hasFlightBrandedFares: boolean;
}

export interface FakeDataLoan {
    enabled: boolean;
    type: LoanType;
}

interface FakeDataAffiliate {
    enabled: boolean;
    affiliateId: string;
    salesChannel: SalesChannel;
    businessArea: BusinessArea;
    groupName: string;
}

export enum CombinationIdType {
    None = 'None',
    Some = 'Some',
    All = 'All',
}

export enum DevCancellationType {
    Random = 'Random',
    Full = 'Full',
}

interface FakeDataSearch {
    enabled: boolean;
    adults: {
        min: number;
        max: number;
    };
    children: {
        min: number;
        max: number;
    };
    infants: {
        min: number;
        max: number;
    };
}
export interface FakeDataBooking {
    status: MyBookingStatus;
    createdToday: boolean;
    canDisplayPaymentReminder: boolean;
    hasServicePackage: boolean;
    servicePackageSelection: ProductType | undefined;
    hasCustomerServiceMessages: boolean;
    hasImportantInformation: boolean;
    hasLeaBankPayment: boolean;
    hasDownPayment: boolean;
    hasFinalPayment: boolean;
    hasCloseFinalPayment: boolean;
    hasAmountAlreadyPaid: boolean;
    ryanair: FakeDataRyanair;
}

export interface FakeDataBookingSession {
    hasServicePackage: boolean;
    hasServicePackageBasic: boolean;
    hasServicePackagePremium: boolean;
}

interface FakeDataRyanair {
    enabled: boolean;
    isConfirmed: FakeDataRyanairOption;
    isUrlValid: FakeDataRyanairOption;
    hasUrl: FakeDataRyanairOption;
}

export enum FakeDataRyanairOption {
    None = 'None',
    Some = 'Some',
    All = 'All',
}

export interface FakeDataBookings {
    isAuthenticated: boolean;
    isVerified: boolean;
    count: number;
}
